import React from 'react'
import { useFetch } from '../../hooks/useFetch'
import DataGridView from '../DataGridView';
import { Container, Grid, TextField, Button, Typography, createTheme, Box, Link } from '@mui/material'
import { useState, useEffect } from 'react';
import SelectLevel from '../SelectLevel'
import { useAuthContext } from '../../hooks/useAuthContext'


function ViewCourseFeesForQuote({ quoteId, handleCompelte, catId, setCatId, setAddCourse }) {
    const { accessLevel, parentID, user } = useAuthContext()
    const [tableData, setTableData] = useState([])
    const { error, errorMessage, isPending, data } = useFetch(`https://dcregapi.bi-oss.co.za/quote/viewfees/${quoteId}`)

    const { postData, error: error2, errorMessage: errorMessage2, isPending: isPending2, data: addedCourse } = useFetch(`https://dcregapi.bi-oss.co.za/quote/${quoteId}`, 'POST')



    useEffect((tableData) => {
        if (data) {
            setTableData(data)

        }


    }, [data])





    useEffect(() => {
        if (addedCourse) {

            handleCompelte()
        }
    }, [addedCourse])


    const submitCourse = (courseId) => {
        postData({
            createdBy: user.email,
            courseId
        })
    }
    const columns = [


        {
            field: "courseCode",
            headerName: "Action",
            width: 150,
            renderCell: (params) => {
                const onClick1 = (e) => {
                    e.stopPropagation() // don't select this row after clicking

                    submitCourse(params.row.courseId)



                }


                if (!isPending2) {
                    return <Button color="primary" onClick={onClick1} fullWidth variant="contained">{params.row.courseCode}</Button>;

                }


            }
        },

        { field: 'courseName', headerName: 'Course:', width: 300 },
        { field: 'fee', headerName: 'Fee::', width: 150, float: 'right' },

        {
            field: "action1",
            headerName: "Action",
            width: 150,
            renderCell: (params) => {
                const onClick1 = (e) => {
                    e.stopPropagation() // don't select this row after clicking

                    submitCourse(params.row.courseId)



                }


                if (!isPending2) {
                    return <Button color="primary" onClick={onClick1} fullWidth variant="contained">Add</Button>;

                }


            }
        },





    ];


    const [searchColumns, setSearchColumns] = useState([
        'categoryId',




    ]);


    function search(rows) {
        return rows.filter((row) =>
            searchColumns.some(
                (column) =>
                    row[column]
                        .toString()
                        .toLowerCase()
                        .indexOf(catId) > -1,
            ),
        );
    }





    return (
        <>



            <Container maxWidth="md" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '1', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>
                <Box mb={3} />

                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '0px', borderColor: 'primary.main', borderRadius: 2 }}>
                    <Grid item xs={12}>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >
                            <Typography variant="h6" component="h3" color="primary">
                                Course Selector
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{

                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }}
                        >
                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >

                                    <SelectLevel catId={catId} setCatId={setCatId} />



                                </Box>


                            </Grid>


                        </Box>


                    </Grid>



                    {isPending && !error && (
                        <Grid item xs={12}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <Typography variant="h6" component="h3" color="primary">
                                    Fetching course fees ........
                                </Typography>
                            </Box>
                        </Grid>
                    )}

                    {isPending2 && !error && (
                        <Grid item xs={12}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <Typography variant="h6" component="h3" color="primary">
                                    Updating quote.......
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                    {error && !errorMessage && (
                        <Grid item xs={12}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <Typography variant="h6" component="h3" color="error">
                                    Unable to fetch course fee list. You may be offline. Please try again.


                                </Typography>
                            </Box>
                        </Grid>
                    )}



                    {errorMessage && (
                        <Grid item xs={12}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <Typography variant="h6" component="h3" color="error">
                                    {errorMessage}


                                </Typography>
                            </Box>
                        </Grid>
                    )}

                    {errorMessage2 && (
                        <>
                            <Grid item xs={12}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"

                                >
                                    <Typography variant="h6" component="h3" color="error">
                                        {errorMessage2}


                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"

                                >
                                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"

                                        >
                                            <Button fullWidth onClick={(e) => handleCompelte()} color="primary" variant="contained">View Cart</Button>
                                        </Box>
                                    </Grid>
                                </Box>
                            </Grid>
                        </>
                    )}
                    {!isPending && !error && !isPending2 && !errorMessage2 && (
                        <Grid item xs={12} minWidth={0} >
                            <DataGridView

                                tableData={search(tableData)}
                                error={error} isPending={isPending} getFormattedDate={null} columns={columns} pageSize={100} handleOnCellClick={null}
                                getRowId={(row) => row.id}


                            />
                        </Grid>
                    )}



                    {!errorMessage2 && !isPending && !isPending2 && (

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}

                            >

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >

                                        <Button fullWidth onClick={(e) => setAddCourse(0)} color="primary" variant="contained">View Cart</Button>


                                    </Box>

                                </Grid>

                            </Box>

                        </Grid>
                    )}
                </Grid>
            </Container>

        </>

    )
}

export default ViewCourseFeesForQuote